import { QarepaEnumInformation } from '@qarepa/common';

export enum EmployeeStatusEnum {
  CREATED = 'CREATED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
}

export type EmployeeStatusType =
  | EmployeeStatusEnum.CREATED
  | EmployeeStatusEnum.ACTIVE
  | EmployeeStatusEnum.INACTIVE
  | EmployeeStatusEnum.PENDING
  | EmployeeStatusEnum.CANCELLED;

export const EmployeeStatusArray = [
  EmployeeStatusEnum.CREATED,
  EmployeeStatusEnum.ACTIVE,
  EmployeeStatusEnum.INACTIVE,
  EmployeeStatusEnum.PENDING,
  EmployeeStatusEnum.CANCELLED,
];

export const EmployeeStatusInfo: QarepaEnumInformation<EmployeeStatusEnum> = {
  [EmployeeStatusEnum.CREATED]: {
    name: $localize`Creado`,
  },
  [EmployeeStatusEnum.ACTIVE]: {
    name: $localize`De Alta`,
  },
  [EmployeeStatusEnum.INACTIVE]: {
    name: $localize`No Empleado`,
  },
  [EmployeeStatusEnum.PENDING]: {
    name: $localize`Pendiente`,
  },
  [EmployeeStatusEnum.CANCELLED]: {
    name: $localize`Cancelado`,
  },
};

export enum EmployeeStatusSelectorEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const EmployeeStatusSelectorArray = [
  EmployeeStatusSelectorEnum.ACTIVE,
  EmployeeStatusSelectorEnum.INACTIVE,
];

export const EmployeeStatusSelectorInfo: QarepaEnumInformation<EmployeeStatusSelectorEnum> =
  {
    [EmployeeStatusSelectorEnum.ACTIVE]: {
      name: $localize`De alta`,
    },
    [EmployeeStatusSelectorEnum.INACTIVE]: {
      name: $localize`No Empleados`,
    },
  };
